
import * as d3 from 'd3'
export default {
  methods: {

    draw_Header() {
      
      let head = this.canvasForm
      .append('g')
      .attr('transform', `translate(${this.header.x+.5}, ${this.header.y+.5})`)

      let height = this.header.height
      head
      .append('path') // shadow
      .attr('d', `M5,${height + 2} H ${this.header.width-7} L ${this.header.width},${height + 7} H0 Z`)
      .attr('fill', `url(#shadowTimeline)`) 

      head
      .append('rect') 
      .attr('x', 0).attr('y', 0).attr('width', this.header.width).attr('height', 2)
      .attr('fill', `url(#${this.localId}_LightGray_)`).attr('opacity', .99)

      head
      .append('rect')
      .attr('x', 0).attr('y', 2).attr('width', this.header.width).attr('height', height)
      .attr('fill', `url(#${this.localId}_LightGray_)`).attr('opacity', .5)

      head
      .append('rect')
      .attr('x', 0).attr('y', 2).attr('width', this.header.group[0].width).attr('height', height)
      .attr('fill', `url(#${this.localId}_LightBlue_)`).attr('opacity', .2)

      head
      .append('rect') 
      .attr('x', 0).attr('y', height + 1).attr('width', this.header.width).attr('height', 3)
      .attr('fill', `url(#${this.localId}_LightGray_)`)

      
      let x_ = 0
      this.header.group.forEach((d,i)=> {

        if(i<this.header.group.length-1)
        this.gmx_Line(head, d.ex, d.ex, 5, height-5, '#bcbcbc', .5, 1)

        head
        .append('text')
        .attr('x', d.mx).attr('y', 20)
        .attr('font-size', 12).attr('fill', '#000')
        .attr('text-anchor', d.align)
        .text(d.name)
      })
    },

  }
}